import { render, staticRenderFns } from "./ApiTable.vue?vue&type=template&id=6fd7b2ce&scoped=true&"
import script from "./ApiTable.vue?vue&type=script&lang=js&"
export * from "./ApiTable.vue?vue&type=script&lang=js&"
import style0 from "./ApiTable.vue?vue&type=style&index=0&id=6fd7b2ce&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd7b2ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
